import axios from "axios"

export const LadderService = {

    getCurrentLadder: async token => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ladder`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
}